import { z } from "zod";
import { optionalText, pixKeyTypeSchema, requiredText } from "./common.js";
const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .email({ message: "Informe um e-mail válido." })
    .max(180);
const passwordSchema = z
    .string()
    .min(8, { message: "A senha precisa de pelo menos 8 caracteres." })
    .max(128, { message: "A senha é longa demais." });
export const signupSchema = z.object({
    name: requiredText(120, "nome"),
    email: emailSchema,
    password: passwordSchema,
});
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, { message: "Informe a senha." }),
});
export const updateProfileSchema = z
    .object({
    name: requiredText(120, "nome").optional(),
    pixKeyType: pixKeyTypeSchema.nullable().optional(),
    pixKey: optionalText(140).nullable(),
})
    .refine((data) => !(data.pixKey && !data.pixKeyType), {
    message: "Escolha o tipo da chave Pix.",
    path: ["pixKeyType"],
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1, { message: "Informe a senha atual." }),
    newPassword: passwordSchema,
});
export const googleLoginSchema = z.object({
    credential: z.string().min(1, { message: "Token do Google obrigatório." }),
});
//# sourceMappingURL=auth.js.map